import React from 'react';

/**
 * Top-of-page stats grid for the Admin Library.
 * Stateless — takes the `stats` payload from /api/admin/stats.
 */
export default function AdminStatsGrid({ stats }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4" data-testid="stat-users">
        <div className="text-zinc-400 text-xs uppercase tracking-wide">Users</div>
        <div className="text-2xl font-bold text-[#00D26A]">{stats.users ?? 0}</div>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4" data-testid="stat-library">
        <div className="text-zinc-400 text-xs uppercase tracking-wide">Library entries</div>
        <div className="text-2xl font-bold text-[#FFD700]">{stats.media_library ?? 0}</div>
        <div className="text-zinc-500 text-xs mt-1">
          {Object.entries(stats.library_by_status || {}).map(([k, v]) => `${k}: ${v}`).join(' · ') || '—'}
        </div>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4" data-testid="stat-scans">
        <div className="text-zinc-400 text-xs uppercase tracking-wide">Total scans</div>
        <div className="text-2xl font-bold text-white">{stats.scans ?? 0}</div>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4" data-testid="stat-price-checks">
        <div className="text-zinc-400 text-xs uppercase tracking-wide">Price checks</div>
        <div className="text-2xl font-bold text-white">{stats.price_checks ?? 0}</div>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4 md:col-span-2" data-testid="stat-earnings">
        <div className="text-zinc-400 text-xs uppercase tracking-wide">Lifetime earnings paid out</div>
        <div className="text-2xl font-bold text-[#00D26A]">£{stats.totals?.lifetime_earnings_gbp?.toFixed(2) ?? '0.00'}</div>
        <div className="text-zinc-500 text-xs mt-1">Withdrawable balance total: £{stats.totals?.withdrawable_balance_gbp?.toFixed(2) ?? '0.00'}</div>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-4 md:col-span-2" data-testid="stat-vip">
        <div className="text-zinc-400 text-xs uppercase tracking-wide">Founding 100 VIPs</div>
        <div className="text-2xl font-bold text-[#FFD700]">{stats.vip_registrations ?? 0}</div>
        <div className="text-zinc-500 text-xs mt-1">Waitlist: {stats.waitlist_signups ?? 0} · Contact: {stats.contact_enquiries ?? 0}</div>
      </div>
    </div>
  );
}
